import * as React from "react";
import axios from "axios";
import { ErrorBoundary } from "react-error-boundary";
import { Navigate } from 'react-router-dom';
import { makeStyles } from "@mui/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/chartsStyle.js";
import { useEffect, useState, useContext } from "react";
import { getDashboardViews } from "services/ConfigServices";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import ErrorFallbackDialog from "components/ErrorFallback/ErrorFallbackDialog";
import SelectingHeader from "components/Analyses/SelectingHeader";
import LoadingApp from "components/Modal/LoadingApp";
import UserService from "services/UserService";
import postPageVisit from "services/LogService";
const useStyles = makeStyles(styles);

export default function Analyses() {
  const classes = useStyles();
  const [pageCategory, setPageCategory] = useState([]);
  const [pageCategoryCampaigns, setPageCategoryCampaigns] = useState([]);
  const [dashboard, setDashboard] = useState([]);
  const [dashboardcampaigns, setDashboardcampaigns] = useState([]);

  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, setPage } = appContext;
  const [redirState, setRedirState] = useState(false);

  let redirecting = redirState && (
    <Navigate
      push
      to={{
        pathname: "/admin/analyses",
      }}
    />
  );

  useEffect(() => {
    setPage('analyse');
    postPageVisit('analyse');
    //getPageAnalyse();
  }, []);

  //get first select options

  // const getPageAnalyse = () => {
  //   const dashboard = JSON.parse(localStorage.getItem("pageAnalyse")) || [];
  //   let category = [];
  //   dashboard.map((page) => {
  //     let namePage = page.name;
  //     category = category.concat([namePage]);
  //   });
  //   return setPageCategory(category);
  // };

  return (
    <div className={classes.container}>
      <ErrorBoundary
        onReset={() => setRedirState(true)}
        FallbackComponent={ErrorFallbackDialog}
        page={"analyse"}
      >
        {chartIdGroup[0] !== "0" ? (
          <SelectingHeader
            // categories={pageCategory}
            // categoriescampaign={pageCategoryCampaigns}
            // dashboard={dashboard}
            // dashboardcampaigns={dashboardcampaigns}
          />
        ) : (
          <LoadingApp open={chartIdGroup[0] === "0" ? true : false} />
        )}
        {redirecting}
      </ErrorBoundary>
    </div>
  );
}
